export default __webpack_public_path__ + "../staticImages/winefinder-sprite-Aroma_schwarze_Fruechte-2x.png";